// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-starter[data-v-d760b6d6]{width:320px}.flow-starter__header[data-v-d760b6d6]{display:flex;margin-top:12px;margin-left:22px}.flow-starter__title[data-v-d760b6d6]{margin-top:10px;font-size:20px;flex:100px;color:#161616;white-space:nowrap}.flow-starter__close-btn[data-v-d760b6d6]{flex:100px;display:flex;justify-content:flex-end}.bx--btn__icon[data-v-d760b6d6]{width:20px;height:20px}.bx--btn__color[data-v-d760b6d6]{color:#161616}", ""]);
// Exports
module.exports = exports;
